import React, { useState } from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useTransactionsMercadoPagoHook } from './hooks/useTransactionsMercadoPagoHook';
import DataTable from 'widgets/datagrid/DataTable';
import CustomDialog from 'widgets/component/CustomDialog';
import FiltroMercadoPago from './components/FiltroMercadoPago';
import { mercadoPagoAction } from '_models/redux/list-transactions-mercadopago/action';
import { cleanMercadoPagoAction } from '_models/redux/list-transactions-mercadopago/clean-action';
import { detailMercadoPagoAction } from '_models/redux/detail-transactions-mercadopago/action';
import { cleanDetailMercadoPagoAction } from '_models/redux/detail-transactions-mercadopago/clean-action';
import { actionReportTransactionsFraud } from '_models/redux/report-transaction-fraud/action';
import { cleanReportTransactionsFraud } from '_models/redux/report-transaction-fraud/clean_action';
import { cleanReportPrepaidChargebackDetails } from '_models/redux/report-transaction-chargeback/clean_action';
import { actionReportTransactionsChargeback } from '_models/redux/report-transaction-chargeback/action';
import FraudConfirmationDialog from './components/FraudConfirmationDialog';
import TransactionDetailsDialog from './components/TransactionDetailsDialog';

const PageTransactionsMercadoPago = ({
  mercadoPagoAction,
  listMercadoPago,
  cleanMercadoPagoAction,
  cleanDetailMercadoPagoAction,
  detailMercadoPagoAction,
  detailTransactionsMercadoPago,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  reportTransactionsFraud,
  reportTransactionsChargeback,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    error,
    handleConfirm,
    loadingFraudAndChargeback,
    isError,
    handleCloseFraudChargeback,
    setOpenActionFraud,
    handleOpenPopUp,
    setIdReverso,
    setActiveAction,
    setShouldReturnData,
    activeAction,
    shouldReturnData,
    titleDialogMessage,
  } = useTransactionsMercadoPagoHook({
    mercadoPagoAction,
    listMercadoPago,
    cleanMercadoPagoAction,
    cleanDetailMercadoPagoAction,
    detailMercadoPagoAction,
    detailTransactionsMercadoPago,
    actionReportTransactionsFraud,
    cleanReportTransactionsFraud,
    reportTransactionsFraud,
    reportTransactionsChargeback,
    cleanReportPrepaidChargebackDetails,
    actionReportTransactionsChargeback,
    transactionId,
    onClose,
  });
  const [hasSearched, setHasSearched] = useState(false);
  const onSubmitWithFlag = (...args) => {
    setHasSearched(true);
    return onSubmit(...args);
  };
  return (
    <Box>
      <Grid>
        <h4> Transacciones de Mercado Pago</h4>
      </Grid>
      <Box sx={{ mb: 5 }}>
        <FiltroMercadoPago
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Box>
      {loading && <CircularProgress />}
      {mappedRows?.length > 0 ? (
        <Box>
          <DataTable
            rows={mappedRows}
            columns={Columns}
            onRowClick={handleRowClick}
            page={page}
            pageSize={size}
            rowCount={pagination?.total_rows ?? 0}
            onPageChange={pagination?.handleChangePage}
            handleChangePageSize={pagination?.handleChangePageSize}
            loading={loading}
          />
        </Box>
      ) : (
        mappedRows.length === 0 &&
        !loading &&
        hasSearched && <Typography variant='h6'>No hay registros disponibles</Typography>
      )}

      <TransactionDetailsDialog
        open={isDialogOpenDetails}
        onClose={handleClose}
        loading={loading}
        detailTransactionsMercadoPago={detailTransactionsMercadoPago}
        handleOpenPopUp={handleOpenPopUp}
        setOpenActionFraud={setOpenActionFraud}
        setIdReverso={setIdReverso}
        setActiveAction={setActiveAction}
        setShouldReturnData={setShouldReturnData}
        activeAction={activeAction}
        shouldReturnData={shouldReturnData}
      />

      <CustomDialog
        title={titleDialogMessage}
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />

      <FraudConfirmationDialog
        open={openActionFraud}
        onClose={handleCloseFraudChargeback}
        setDescriptionTransaction={setDescriptionTransaction}
        setError={setError}
        error={error}
        handleConfirm={handleConfirm}
        loadingFraudAndChargeback={loadingFraudAndChargeback}
        dialogMessage={dialogMessage}
        isError={isError}
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  listMercadoPago: state?.listMercadoPago,
  detailTransactionsMercadoPago: state?.detailTransactionsMercadoPago,
  reportTransactionsFraud: state?.reportTransactionsFraud,
  reportTransactionsChargeback: state?.reportTransactionsChargeback,
});

const mapDispatchToProps = {
  mercadoPagoAction,
  cleanMercadoPagoAction,
  cleanDetailMercadoPagoAction,
  detailMercadoPagoAction,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageTransactionsMercadoPago);
